import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from '../ui/button';
import { usePreApproval } from '../../pages/LandingPage';

const VideoPresentation = () => {
  const { openPreApproval } = usePreApproval();

  return (
    <section className="py-16 md:py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Header */}
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Play className="w-6 h-6 text-emerald-400" />
            <span className="text-emerald-400 font-semibold text-sm uppercase tracking-wider">8 Minute Presentation</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
            Watch this AI Horse-Powered Video if You're Pre-Approved
            <span className="block text-cyan-400 mt-2">or Simply Want to Learn More</span>
          </h2>
        </div>

        {/* Video Container */}
        <div className="relative mb-10 md:mb-12">
          {/* Glow Effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 rounded-2xl blur-2xl transform scale-105" />
          
          {/* Video */}
          <div className="relative rounded-2xl overflow-hidden border-2 border-slate-700/50 shadow-2xl">
            <video 
              src="https://customer-assets.emergentagent.com/job_fundingpath/artifacts/uhqn04c7_One%20Force%20Live%27s%20Video%20Presentation%20%28Video%29%20%284%29.mp4"
              className="w-full h-auto"
              autoPlay
              muted
              loop
              playsInline
              controls
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Subline CTA and Button */}
        <div className="text-center">
          <p className="text-lg md:text-xl text-slate-300 mb-8">
            Not pre-approved yet?{' '}
            <span className="text-cyan-400 font-semibold">Complete your 3-minute $120K Co-Op Pre-Approval</span>
          </p>

          {/* Step 1 Button */}
          <Button
            onClick={openPreApproval}
            size="lg"
            data-testid="video-presentation-cta-btn"
            className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-400 hover:to-emerald-500 text-slate-950 font-bold px-10 py-6 text-lg rounded-xl transition-all hover:shadow-xl hover:shadow-emerald-500/30 group"
          >
            <span className="bg-slate-950 text-emerald-400 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm font-bold">1</span>
            Start Pre-Approval
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default VideoPresentation;
